<template>
  <div class="card">
    <h3>Fiyat Grafiği</h3>
    <div class="period-selector">
      <button
        v-for="(rate, label) in changeRates"
        :key="label"
        @click="updateChartByPeriod(label)"
        :class="{ active: selectedPeriod === label }"
        class="period-button"
      >
        {{ label }}
        <span
          class="period-rate"
          :class="{ positive: rate > 0, negative: rate < 0 }"
        >
          {{ rate }}%
        </span>
      </button>
    </div>

    <div class="chart-wrapper">
      <Line
        v-if="chartTarihselFiyat"
        :data="chartTarihselFiyat"
        :options="lineChartOptions"
      />
    </div>
  </div>
</template>

<script>
import { Line } from "vue-chartjs";
import { lineChartOptions } from "@/charts/lineChartHelpers";
import { generateChartTarihselFiyat } from "@/charts/lineChartHelpers";
import { calculateChangeRates } from "@/charts/changeRateCalculations";
import { filterTarihselFiyatByPeriod } from "@/charts/chartPeriodHelpers";

export default {
  components: {
    Line,
  },
  props: {
    tarihselFiyatBilgileri: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      lineChartOptions,
      chartTarihselFiyat: null,
      selectedPeriod: "2 Yıllık",
      changeRates: {},
    };
  },
  watch: {
    tarihselFiyatBilgileri: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.updateChartByPeriod(this.selectedPeriod);
        }
      },
    },
  },
  methods: {
    updateChartByPeriod(period) {
      if (!this.tarihselFiyatBilgileri) return;

      this.selectedPeriod = period;

      this.changeRates = calculateChangeRates(this.tarihselFiyatBilgileri);

      const filteredTariselFiyatBilgileri = filterTarihselFiyatByPeriod(
        this.tarihselFiyatBilgileri,
        period
      );

      const isMobil = window.innerWidth <= 768;
      this.chartTarihselFiyat = generateChartTarihselFiyat(
        filteredTariselFiyatBilgileri,
        isMobil
      );
    },
  },
};
</script>

<style scoped>
.card {
  background-color: var(--card-bg);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.card h3 {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 1rem;
}

.period-selector {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
}

.period-button {
  padding: 0.5rem 1rem;
  background-color: var(--card-dark);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-secondary);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.period-button:hover {
  background-color: var(--hover-bg);
}

.period-button.active {
  border-color: var(--primary-light);
  background-color: rgba(59, 130, 246, 0.1);
  color: var(--primary-light);
}

.period-rate {
  font-weight: 600;
}

.positive {
  color: var(--success-color);
}

.negative {
  color: var(--danger-color);
}

.chart-wrapper {
  height: 400px;
  background-color: var(--card-dark);
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid var(--border-color);
}

@media (max-width: 768px) {
  .card {
    padding: 1rem;
    margin-bottom: 1rem;
  }

  .card h3 {
    font-size: 16px;
    margin-bottom: 0.75rem;
  }

  .period-selector {
    justify-content: center;
    gap: 0.3rem;
    margin-bottom: 1rem;
  }

  .period-button {
    padding: 0.4rem 0.75rem;
    font-size: 12px;
    flex: 0 0 calc(33.333% - 0.3rem);
    justify-content: center;
  }

  .chart-wrapper {
    height: 400px;
    padding: 0.75rem;
  }
}

@media (max-width: 480px) {
  .period-button {
    flex: 0 0 calc(50% - 0.3rem);
    padding: 0.3rem 0.5rem;
    font-size: 11px;
  }

  .chart-wrapper {
    height: 350px;
    padding: 0.5rem;
  }

  .period-rate {
    font-size: 11px;
  }
}

@media (max-width: 360px) {
  .card {
    padding: 0.75rem;
  }

  .period-button {
    flex: 0 0 calc(50% - 0.2rem);
    padding: 0.25rem 0.4rem;
    gap: 0.25rem;
  }

  .chart-wrapper {
    height: 300px;
  }
}
</style>
